import React, { useEffect, useState } from 'react'
import PageHeader from '../../view/pageheader'
import TableComponent from '../CustomComponents/TableComponent'
import { Button, Card, DatePicker, Input, Modal, Select, Space } from 'antd'
import { SearchOutlined, ArrowRightOutlined } from '@ant-design/icons'
import SearchComponent from '../CustomComponents/SearchComponent'
import dayjs from 'dayjs'
import { getAllBoxes } from '../../store/reducer/jobSlice'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import { getEventList } from '../../store/reducer/eventSlice';

const ReportsData = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { getAllBoxesData } = useSelector((state) => state.jobs);
    const { eventListData, } = useSelector((state) => state.events);
    const [searchModal, setSearchModal] = useState(false)
    const [searchText, setSearchText] = useState('');
    const [searchDate, setSearchDate] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const { count: totalCount, data: tableData } = getAllBoxesData || {};

    const columns = [
        {
            title: 'Barcode',
            dataIndex: 'barcode',
            key: 'barcode',
            align: 'center',
        },
        {
            title: 'Spec ID',
            dataIndex: 'spec_id',
            key: 'spec_id',
            align: 'center',
        },
        {
            title: 'Spec Box No',
            dataIndex: 'spec_box_number',
            key: 'spec_box_number',
            align: 'center',

        },

        {
            title: 'Stage',
            dataIndex: 'event_stage',
            key: 'event_stage',
            align: 'center',
            render: data => {
                if (data) {
                    return <span>{data}</span>
                } else {
                    return <span>Prep</span>
                }
            }

        },
        {
            title: 'Box Status',
            dataIndex: 'box_status',
            key: 'box_status',
            align: 'center',
            render: (state) => {
                return state == 0 ? <span>New</span> : <span>Completed</span>;
            }
        },
        {
            title: 'Pickup Date',
            dataIndex: 'pickup_date',
            key: 'pickup_date',
            align: 'center',
            render: (data) => {
                return data ? dayjs(data).format('MM/DD/YYYY') : '-'; // Format date to MM/DD/YYYY
            }
        },
        {
            title: 'View Event History',
            key: 'action',
            align: 'center',
            render: (_, record) => (
                <Space size="middle">
                    {/* <Button className="primary-btn rounded-4">View</Button> */}
                    <Button onClick={() =>
                        navigate(`/view-event-stages-history/${window.btoa(record.barcode)}`)
                    } icon={<ArrowRightOutlined />} className="primary-btn rounded-1"></Button>
                </Space>
            ),
        }
    ]
    function getData(payload = {}) {
        dispatch(getEventList({ query: "" }));
        dispatch(getAllBoxes(payload))

    }
    useEffect(() => {
        // Fetch initial data when component mounts
        getData();
    }, []);
    const handleSearchClick = () => {
        if (!searchValue.trim()) {
            // If search is empty, reset to initial data
            getData({ query: "" }); // Pass empty query to fetch all data
            return;
        }
        const payloadData = {
            query: searchValue,
        };
        getData(payloadData);
        // localStorage.removeItem('barcode');
    };
    const handleSearch = () => {
        const payloadData = {
            query: searchText,
        };


        // Add pickup_date only if selected
        if (searchDate) {
            payloadData.pickup_date = dayjs(searchDate).format('MM/DD/YYYY'); // send in MM/DD/YYYY format
        }
        getData(payloadData);
        setSearchModal(false)
        setSearchDate(null)
        setSearchText('');

    };
    const eventData = eventListData?.data?.map((item) => ({
        value: item.id,
        label: item.eventname,
    }))
    return (
        <>
            <PageHeader HeaderText="Reports" Breadcrumb={[{ name: "Reports" }]} />
            <Card style={{ marginTop: "-28px", }}
                extra={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "12px",
                            margin: "16px 0"
                        }}
                    >
                        {/* Left Side: Search + Buttons */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                flexWrap: "wrap"
                            }}
                        >
                            <SearchComponent
                                style={{ width: "300px" }}
                                placeHolder="Search Box Number"
                            />
                            <Button className="primary-btn rounded-4">
                                Search Box Number
                            </Button>
                            <Button
                                style={{
                                    background: "linear-gradient(45deg, #56ab2f, #a8e063)",
                                    border: "none",
                                    color: "white"
                                }}
                                onClick={() => navigate('/monetization')}
                                className="rounded-4"
                            >
                                Monetization Reports
                            </Button>
                            <Button style={{
                                background: "linear-gradient(45deg, #36d1dc, #5b86e5)",
                                border: "none",
                                color: "white"
                            }} className="rounded-4">
                                Job Inspection  Reports
                            </Button>
                        </div>

                        {/* Right Side: Search Filter Button */}
                        <Button
                            className="primary-btn"
                            shape="round"
                            type="primary"
                            onClick={() => setSearchModal(true)}
                        >
                            Search Filter
                        </Button>

                        {/* Search Filter Modal */}
                        <Modal
                            open={searchModal}
                            onCancel={() => setSearchModal(false)}
                            onOk={handleSearch}
                            okText="Search"
                            title={
                                <span>
                                    Search Filter <SearchOutlined style={{ marginRight: 6 }} />
                                    <hr />
                                </span>
                            }
                            width={600}
                        >
                            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                {/* First Line: Spec */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <label style={{ marginBottom: "6px", fontWeight: "bold" }}>
                                        Search by Spec
                                    </label>
                                    <Input
                                        placeholder="Enter Spec"
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                </div>

                                {/* Second Line: Pickup Date */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <label style={{ marginBottom: "6px", fontWeight: "bold" }}>
                                        Pickup Date
                                    </label>
                                    <DatePicker
                                        style={{ width: "100%" }}
                                        placeholder="Select Pickup Date"
                                        value={searchDate}
                                        onChange={(date) => setSearchDate(date)}
                                        format="MM/DD/YYYY"
                                    />
                                </div>

                                {/* Third Line: Event Stage */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <label style={{ marginBottom: "6px", fontWeight: "bold" }}>
                                        Filter By Event Stage
                                    </label>
                                    <Select
                                        options={[
                                            { value: "Scan", label: "Scan" },
                                            { value: "Prep", label: "Prep" },
                                            { value: "OCR", label: "OCR" },
                                        ]}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                }
            >
                <TableComponent columns={columns} dataSource={tableData} size={"small"} />
            </Card>


        </>
    )
}

export default ReportsData